export const getRGLimitsRedirectUrl = ({
  isAdditionalInformationRequired,
  isMandatoryLimitPageRequiresUserVerification,
  isNeedSetupLimits,
  isPassportInVerification,
  isPassportVerifiedByRisk,
  mandatoryLimit,
  nextPageCached,
  profileDocuments
}) => {
  if (isNeedSetupLimits) {
    const isVerifiedUser =
      isPassportInVerification ||
      isPassportVerifiedByRisk ||
      isAdditionalInformationRequired;

    const redirectUrl =
      isMandatoryLimitPageRequiresUserVerification && !isVerifiedUser
        ? profileDocuments
        : mandatoryLimit;

    return redirectUrl;
  }

  return nextPageCached.current;
};
